// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

// export function myRouter_Router(request) {

//   let userAgent = request.userAgent;
//   // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_4) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/57.0.2987.133 Safari/537.36"
// 	console.log(userAgent);	

// }

$w.onReady(function () {

	//Code below detects if viewport has passed a transparent line element on page and loads different header nav appropriately
	$w("#navLine").onViewportLeave(() => {
 		let fadeOptions = {
 		"duration":   300,
 		"delay":      0
    };
    $w('#starterNav').hide("fade", fadeOptions);
	$w('#hiddenNavLine').show("fade", fadeOptions);
    $w('#hiddenNav').show("fade", fadeOptions);
})

	$w("#navLine").onViewportEnter(() => {
 		let fadeOptions = {
 		"duration":   300,
 		"delay":      0
    };
    $w('#starterNav').show("fade", fadeOptions);
	$w('#hiddenNavLine').hide("fade", fadeOptions);
    $w('#hiddenNav').hide("fade", fadeOptions);
})

	$w("#navLine2").onViewportLeave(() => {
 		let fadeOptions = {
 		"duration":   300,
 		"delay":      0
    };
    // $w('#starterNav').hide("fade", fadeOptions);
    $w('#hiddenNav').show("fade", fadeOptions);
})

	//Code to check specifically for iPad
	
	//USER AGENT CHECK	
	var userAgent = navigator.userAgent;
	let iPadCheck1 = userAgent.includes("iPad");
	// let iPadCheck2 = userAgent.includes("");

	if (iPadCheck1 === true && wixLocation.url !== 'https://www.mikelevin.org/?showmobileview=true') {
		wixLocation.to("https://www.mikelevin.org/?showmobileview=true");
	} 

	//SIZE CHECK
	wixWindow.getBoundingRect()
  	.then(winInfo => {
    	let winHeight = winInfo.window.height; 
    	let winWidth = winInfo.window.width; 
			if(winWidth <= 1024 && wixLocation.url !== 'https://www.mikelevin.org/?showmobileview=true') {
				wixLocation.to("https://www.mikelevin.org/?showmobileview=true");
			}
	});

	
	//FORM FACTOR CHECK
	if (wixWindow.formFactor === "Tablet" && wixLocation.url !== 'https://www.mikelevin.org/?showmobileview=true') {
		wixLocation.to("https://www.mikelevin.org/?showmobileview=true");
	}
	
});



